// import {ValidatorsModuleConfig} from "../../common-shared/validators/types";

export const validatorsConfig /*: ValidatorsModuleConfig */ = {
  email: {
    value:
      '^([\\w-]+(?:\\.[\\w-#]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$',
  },
  name: { value: '^.{1,100}$' },
  username: {
    value:
      '^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$',
  },
  url: {
    value: '^(www|http:|https:)+[^\\s]+[\\w]$',
  },
  code: { value: '^.{5,50}$' },
  password: { value: '^.{6,35}$' },
  code2fa: { value: '^.{6,6}$' },
  recaptcha: { value: '^.{100,1000}$' },
  date: { value: '^[0-9]{1,4}-[0-9]{0,2}-[0-3][0-9]$' },
  phone: { value: '^.{1,50}$' },
  address: { value: '^.{1,100}$' },
  nationality: { value: '^.{1,100}$' },
  workpermit: { value: '^.{1,100}$' },
  langshort: { value: '^[a-z]{2,2}$' },
  shareCVId: { value: '^[A-Za-z0-9\\.]{2,30}$' },
  folderLabel: { value: '^.{1,30}$' },
};
